import { DateTime as DateTime$1 } from "../../../../../components/DateTime/index.js";
import { UserName } from "../../../../Users/shared/UserName.js";
import "react";
import { ColorCircle, Icon, Timeline } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdAccessTime } from "react-icons/md";
//#region src/modules/Events/shared/EventInteractive/components/EventAssignedUserStatusHistory.tsx
function EventAssignedUserStatusHistory({ event, userId }) {
	const data = event.usersStatusHistory.filter((statusHistory) => {
		if (userId) return statusHistory.userId === userId;
		return true;
	});
	return /* @__PURE__ */ jsx(Timeline, {
		icon: /* @__PURE__ */ jsx(Icon, { Icon: MdAccessTime }),
		data,
		iconBgColor: "neutral",
		render: (item) => /* @__PURE__ */ jsxs("div", { children: [
			item.color && /* @__PURE__ */ jsx(ColorCircle, { color: item.color }),
			" ",
			/* @__PURE__ */ jsx("span", { children: item.title }),
			" ",
			/* @__PURE__ */ jsx(UserName, { userId: item.userId }),
			item.setByUserId !== item.userId && /* @__PURE__ */ jsxs("div", {
				className: "text-xxs text-color-neutral italic",
				children: ["Set by ", /* @__PURE__ */ jsx(UserName, { userId: item.setByUserId })]
			})
		] }),
		renderTimestamp: (item) => /* @__PURE__ */ jsx(DateTime$1, { timestamp: item.setAtDate })
	});
}
//#endregion
export { EventAssignedUserStatusHistory };

//# sourceMappingURL=EventAssignedUserStatusHistory.js.map